/* Duskhaven product cards: "Add to cart" (Oct 2026).
 * Cards for one-variant products carry a small form (form[data-dh-card-atc], rendered by snippets/dh-product-card.liquid).
 * This adds the item without leaving the page, tells the theme's cart (same event the quick view uses, so the
 * drawer contents and header count refresh), opens the cart drawer and shows Adding / Added on the button.
 * If anything fails the button says so and offers a retry. Without JavaScript the form posts to /cart/add as normal.
 * "Choose options" buttons are plain quick view triggers handled by dh-card-gallery.js.
 * 2026-10-13 (Duskhaven 4.5): the card's variant tray (.dh-card-tray) uses the same forms, one per variant; a chip carries
 * data-dh-atc-idle (its variant name) so it returns to that label after "Added" instead of "Add to cart". */
(function () {
  'use strict';
  if (window.__dhCardAtc) return;
  window.__dhCardAtc = true;

  var eventsModule = null;
  function loadEvents() {
    if (!eventsModule) {
      eventsModule = new Promise(function (resolve) {
        var done = function () { resolve(window.__dhShopifyEvents || null); };
        if (window.__dhShopifyEvents) { done(); return; }
        document.addEventListener('dh:shopify-events', done, { once: true });
        setTimeout(done, 3000);
        var script = document.createElement('script');
        script.type = 'module';
        script.textContent = "import('@shopify/events').then(function (m) { window.__dhShopifyEvents = m; })" +
          ".catch(function () {}).then(function () { document.dispatchEvent(new Event('dh:shopify-events')); });";
        document.head.appendChild(script);
      });
    }
    return eventsModule;
  }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  var status = null;
  function announce(text) {
    if (!status) {
      status = document.createElement('p');
      status.className = 'dh-card-atc-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      document.body.appendChild(status);
    }
    status.textContent = '';
    setTimeout(function () { status.textContent = text; }, 50);
  }

  function openDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    try {
      var isOpen = typeof drawer.isOpen === 'function' ? drawer.isOpen() : drawer.isOpen;
      if (!isOpen) drawer.open();
    } catch (e) {}
  }

  function setState(button, label, state, text) {
    button.dataset.state = state;
    label.textContent = text;
    if (state === 'loading') button.setAttribute('aria-busy', 'true');
    else button.removeAttribute('aria-busy');
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[data-dh-card-atc]')) return;
    event.preventDefault();
    var button = form.querySelector('button[type="submit"]');
    if (!button || button.dataset.state === 'loading') return;
    var label = button.querySelector('[data-dh-atc-label]') || button;
    var name = button.getAttribute('data-dh-atc-name') || 'Item';
    var idle = button.getAttribute('data-dh-atc-idle') || 'Add to cart';
    clearTimeout(button.__dhReset);
    setState(button, label, 'loading', 'Adding…');

    var variantId = String(form.querySelector('[name="id"]').value);
    var body = new FormData(form);
    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (element) {
      var id = element.dataset && element.dataset.sectionId;
      if (id && sectionIds.indexOf(id) === -1) sectionIds.push(id);
    });
    if (sectionIds.length) body.append('sections', sectionIds.join(','));

    loadEvents().then(function (events) {
      var Update = events && events.CartLinesUpdateEvent;
      var deferred = Update ? Update.createPromise() : null;
      if (deferred) {
        form.dispatchEvent(new Update({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: variantId, quantity: 1 }],
          promise: deferred.promise
        }));
      }
      return fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body,
        credentials: 'same-origin'
      })
        .then(function (response) { return response.json(); })
        .then(function (result) {
          if (result.status) throw new Error(result.description || result.message || 'Could not add to cart');
          return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
            .then(function (response) { return response.json(); })
            .then(function (cart) {
              if (deferred) {
                deferred.resolve({
                  cart: Update.createCartFromAjaxResponse(cart),
                  detail: { items: cart.items, source: 'dh-card-atc', itemCount: 1, productId: String(result.product_id || ''), sections: result.sections, didError: false }
                });
              }
              document.dispatchEvent(new CustomEvent('duskhaven:cart-updated'));
              setState(button, label, 'added', 'Added');
              announce(name + ' added to your cart.');
              setTimeout(openDrawer, 150);
              button.__dhReset = setTimeout(function () { setState(button, label, 'idle', idle); }, 2400);
            });
        })
        .catch(function (error) {
          if (deferred) deferred.reject(error);
          setState(button, label, 'error', 'Try again');
          announce((error && error.message) || 'Could not add to cart. Please try again.');
          button.__dhReset = setTimeout(function () { setState(button, label, 'idle', idle); }, 3500);
        });
    });
  });
})();
